export const PLAN_DEFINITIONS = {
    free: {
        code: 'free',
        label: 'Pulsuz',
        badgeClass: 'bg-slate-100 text-slate-700',
        features: {
            reports: false,
            branding: false,
            warehouse: false,
            recipes: false,
            menu_sets: false,
            menu_images: false,
            customer_print: false,
            kitchen_print: false,
            room_management: false,
            cash_register: false,
            kassa_ledger: false,
            satis: false,
            ofis: false,
            rental: false,
            purchases: false,
            expenses: false,
            staff: false
        },
        limits: {
            maxTables: 4,
            maxCategories: 3,
            maxMenuItems: 10,
            maxWaiters: 1,
            maxCashiers: 0,
            maxWarehouseUsers: 0,
            maxMenuImages: 0,
            maxPrinters: 1
        }
    },
    basic: {
        code: 'basic',
        label: 'Sadə',
        badgeClass: 'bg-blue-100 text-blue-700',
        features: {
            reports: true,
            branding: true,
            warehouse: false,
            recipes: false,
            menu_sets: false,
            menu_images: true,
            customer_print: true,
            kitchen_print: true,
            room_management: false,
            cash_register: true,
            kassa_ledger: true,
            satis: false,
            ofis: false,
            rental: false,
            purchases: false,
            expenses: true,
            staff: false
        },
        limits: {
            maxTables: null,
            maxCategories: null,
            maxMenuItems: 50,
            maxWaiters: 2,
            maxCashiers: 1,
            maxWarehouseUsers: 0,
            maxMenuImages: null,
            maxPrinters: null
        }
    },
    pro: {
        code: 'pro',
        label: 'Pro',
        badgeClass: 'bg-emerald-100 text-emerald-700',
        features: {
            reports: true,
            branding: true,
            warehouse: true,
            recipes: true,
            menu_sets: true,
            menu_images: true,
            customer_print: true,
            kitchen_print: true,
            room_management: true,
            cash_register: true,
            kassa_ledger: true,
            satis: true,
            ofis: true,
            rental: true,
            purchases: true,
            expenses: true,
            staff: true
        },
        limits: {
            maxTables: null,
            maxCategories: null,
            maxMenuItems: null,
            maxWaiters: null,
            maxCashiers: null,
            maxWarehouseUsers: 1,
            maxMenuImages: null,
            maxPrinters: null
        }
    }
};

export const normalizeTenantPlan = (value) => {
    const raw = String(value || '').trim().toLowerCase();

    if (['pulsuz', 'free'].includes(raw)) return 'free';
    if (['sadə', 'sade', 'basic'].includes(raw)) return 'basic';
    if (['elite', 'premium', 'pro'].includes(raw)) return 'pro';

    return 'pro';
};

export const getPlanDefinition = (plan) => PLAN_DEFINITIONS[normalizeTenantPlan(plan)];
export const hasPlanFeature = (plan, featureKey) => !!getPlanDefinition(plan)?.features?.[featureKey];
export const getPlanLimits = (plan) => getPlanDefinition(plan)?.limits || {};
export const getPlanLimit = (plan, key) => getPlanLimits(plan)?.[key] ?? null;
export const isFreePlan = (plan) => normalizeTenantPlan(plan) === 'free';
export const isBasicPlan = (plan) => normalizeTenantPlan(plan) === 'basic';
export const isProPlan = (plan) => normalizeTenantPlan(plan) === 'pro';
